import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewEncapsulation } from '@angular/core';
import { UserRelationshipGroup, Relationship, RelationshipDataGroup, RelationshipPrivilege,
    Privilege, PrivilegeGroup } from '../../models/UserRelationship';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { UserRelationshipService } from '../../user-relationship.service';
import { PersonService } from '../../../person/person.service';
import { PrivilegeService } from '../../privilege.service';

@Component({
  selector: 'app-edit-user-access',
  templateUrl: './edit-user-access.component.html',
  styleUrls: ['./edit-user-access.component.scss'],
  providers: [ConfirmationService],
  encapsulation: ViewEncapsulation.None
})
export class EditUserAccessComponent implements OnInit, OnDestroy {

  @Input() displayDialog: boolean;
  @Input() userRelationship: UserRelationshipGroup;
  @Input() relationshipIndex:number;
  @Output() onDialogClose = new EventEmitter<boolean>();
  @Output() onEditUser = new EventEmitter<UserRelationshipGroup[]>();
  @Output() onMessage = new EventEmitter<any>();

  readOnly:boolean =false;
  processing = false;
  subscription: Subscription;
  relationship: Relationship[];
  relationshipSelected: Relationship[];
  relationshipDataGroup: RelationshipDataGroup[];
  manageUserRelationshipId: number[] = [];
  userRelationshipGroup: any;
  displayLoginstatus: boolean;
  displayItems: any[];
  relationshipPrivilege: Privilege[];
  relationshipPrivilegeSelected: any;
  userPrivilegeSelected: any[];
  loading = false;
  privilegesSelectedToolTip: any[];
  privilegesSelected: Privilege[];
  privilegeGroup:PrivilegeGroup[];
  privilegeGroupSelected:PrivilegeGroup[];
  userPrivilegeGroupSelected:PrivilegeGroup[];
  privilegesExclude: Privilege[];
  privilegesInclude: Privilege[];
  relationshipPrivilegeData: Privilege[];

  public editUserAccessForm: FormGroup = new FormGroup({
    Relationship: new FormGroup({
      Relationship: new FormControl('', [Validators.required]),
      RelationshipDataGroup: new FormControl('', [Validators.required]),
      PrivilegeGroup: new FormControl(''),
      Privilege: new FormControl('')
    })
  });

  personGroup = this.editUserAccessForm.get('PersonDetail'); 
  relationGroup = this.editUserAccessForm.get('Relationship');
  relationshipControl = this.relationGroup.get('Relationship');
  relationshipDataGroupControl = this.relationGroup.get('RelationshipDataGroup');
  privilegeGroupControl = this.relationGroup.get('PrivilegeGroup');
  privilegeControl = this.relationGroup.get('Privilege');

  constructor(private userRelationshipSvc: UserRelationshipService
       , private userRelationshipPrivilegeSvc: PrivilegeService) { }

  ngOnInit() {
    this.userRelationship = _.cloneDeep(this.userRelationship);
    this.loading = true;
    this.initData();
    if (this.relationshipIndex >= 0) {
      this.readOnly = true;
    } else {
      this.readOnly = false;
    }
    this.displayLoginstatus = this.userRelationship.PersonDetail.IsLocked;
  }

  initData(): void {
    this.relationship = [];
    this.relationshipDataGroup = [];
    this.userPrivilegeSelected = [];
    this.relationship.push({Id: this.userRelationship.Relationship[this.relationshipIndex].Id
      , Company: this.userRelationship.Relationship[this.relationshipIndex].Company});
    if (this.userRelationship.Relationship[this.relationshipIndex].CanAddUser) {
      this.manageUserRelationshipId.push(this.userRelationship.Relationship[this.relationshipIndex].Id);
    }
    for (let j = 0, aGroup = this.userRelationship.Relationship[this.relationshipIndex].RelationshipDataGroup ; j < aGroup.length; j++) {
      this.relationshipDataGroup.push(aGroup[j]);
    }
    this.userPrivilegeSelected = this.userRelationshipPrivilegeSvc
                                  .findByStatus(this.userRelationship.Relationship[this.relationshipIndex].Privileges, true);
    this.relationshipPrivilege = this.userRelationship.Relationship[this.relationshipIndex].Privileges;
    //holding the value to add/remove privileges based on group select/unselect
    this.relationshipPrivilegeData = this.relationshipPrivilege;
    this.userPrivilegeGroupSelected = this.userRelationshipPrivilegeSvc
      .findGroupByStatus(this.userRelationship.Relationship[this.relationshipIndex].PrivilegeGroups, true);
    this.privilegeGroup = this.userRelationship.Relationship[this.relationshipIndex].PrivilegeGroups;
    this.privilegeGroupSelected = this.userPrivilegeGroupSelected;
    // set validation /  excluding privileges those are part of  pirivileggroup
    // from privilege dropdown
    this.refreshPrivilege(this.userPrivilegeGroupSelected);
    this.userPrivilegeSelected = this.excludePrivileges();
    this.setRequired();
  }

  /*
    exclude those privileges are part of group
    from the pre-selected user privileges drop down
  */
  excludePrivileges(): any[] {
    return this.userPrivilegeSelected.filter((userPrivilege: Privilege) =>
                  this.privilegesExclude.map((excludePrivilege: Privilege) =>
                      excludePrivilege.PrivilegeId.toString()).indexOf(userPrivilege.PrivilegeId.toString()) === -1
    );
  }

  onSubmit() {
    if (this.editUserAccessForm.valid) {
      this.processing = true;
      this.processFormdata();
      this.subscription = this.userRelationshipSvc.update([this.userRelationshipGroup])
        .subscribe((user: any) => {
          this.onEditUser.emit(user.data);
          this.processing = false;
          this.displayDialog = false;
      }, error => {
        this.processing = false;
        this.displayDialog = false;
        this.onMessage.emit({severity: 'error', summary: 'Error Occcured while Processing'});
      });
    }
  }

  processFormdata(): void {
    let userRelationship: any;
    this.userRelationshipGroup = this.userRelationship;
    this.userRelationshipGroup.PersonDetail.loginEnabled = this.userRelationship.PersonDetail.IsLocked;
    userRelationship = _.cloneDeep(this.editUserAccessForm.value);
    const aRelationship = [];
    const relationshipData = {};

    for (let i = 0, aData = userRelationship.Relationship.Relationship; i < aData.length; i++) {
      relationshipData['Id'] = aData[i].Id;
      relationshipData['Company'] = aData[i].Company;
      relationshipData['RelationshipDataGroup'] = userRelationship.Relationship
          .RelationshipDataGroup.filter((group: RelationshipDataGroup) => group.RelationshipId === aData[i].Id);
      relationshipData['RelationshipName'] = aData[i].RelationshipName;
      relationshipData['CanAddUser'] = aData[i].CanAddUser;
      relationshipData['Privileges'] = this.userRelationshipPrivilegeSvc.privilegeData(this.privilegesSelected);
      relationshipData['PrivilegeGroups'] = this.userRelationshipPrivilegeSvc.privilegeGroupData(this.privilegeGroupSelected);
      aRelationship.push(relationshipData);
    }
    this.userRelationshipGroup.Relationship[this.relationshipIndex] = relationshipData;
  }

  partnershipChange(relationships: Relationship[]): void {
    this.relationshipSelected = relationships;
    this.relationship = relationships;
  }

  assetGroupChange(relationshipDataGroup: RelationshipDataGroup[]): void {
    this.relationshipDataGroup = relationshipDataGroup;
  }

  displaySelectedItems(op, event, displayItem): void {
    this.displayItems = [];
    if (displayItem === 'Relationship') {
      this.displayItems = this.relationshipSelected.map(items => items.RelationshipName);
    } else if (displayItem === 'Privileges') {
        this.displayItems = this.privilegesSelectedToolTip;
    } else if (displayItem === 'PrivilegeGroup') {
        this.displayItems = this.privilegeGroupSelected;
    } else if (displayItem === 'RelationshipDataGroup') {
      for (let i = 0, aRelation = this.relationshipSelected; i < aRelation.length; i++) {
        for (let j = 0, aGroup = this.relationshipDataGroup; j < aGroup.length; j++) {
          if (aRelation[i].Id === aGroup[j].RelationshipId && this.displayItems.indexOf(aRelation[i]) === -1) {
            this.displayItems.push(aRelation[i]);
          }
        }
      }
    }
    if (this.displayItems !== undefined  && this.displayItems.length) {
     op.show(event);
    }
  }

  dialogClose() {
    this.onDialogClose.emit(false);
  }

  assetGroupByRelationhipId(id) {
    return this.relationshipDataGroup.filter((group) => group.RelationshipId === id);
  }

  privilegeChange(privilege: any): void {
    this.privilegesSelectedToolTip = privilege.PrivilegesToolTip;
    this.privilegesSelected = privilege.Privileges;
    this.setRequired();
  }

  /*
  PrivilegeGroup dropdwon change handler
  */
  onPrivilegeGroupChange(privilegeGroupSelected: PrivilegeGroup[]): void {
    this.privilegeGroupSelected = [];
    this.privilegeGroupSelected = privilegeGroupSelected;
    this.refreshPrivilege(privilegeGroupSelected);
    this.setRequired();
  }
  /*
  remove privileges from privileges dropdwon, those are part of
  selected privilege group
  */
  refreshPrivilege(privilegeGroupSelected: PrivilegeGroup[]): void {
    let privilegeRefreshed: Privilege[] = [];
    this.privilegesExclude = [];
    if (privilegeGroupSelected.length > 0) {
      privilegeGroupSelected.map((privilegeGroup: PrivilegeGroup) => {
        privilegeGroup.Privileges.map((privilege: Privilege) => {
          this.privilegesExclude.push(privilege);
        });
      });
    }
    privilegeRefreshed = this.relationshipPrivilegeData.filter((privilege: Privilege) =>
      this.privilegesExclude.map((privExclude: Privilege) => privExclude.PrivilegeId).indexOf(privilege.PrivilegeId) === -1
    );
    this.relationshipPrivilege = privilegeRefreshed;
  }
  /*
  set privilegeGroup / privilege dropdwon required/not required
 */
  setRequired(): void {
    this.privilegeControl.setValidators(Validators.required);
    this.privilegeGroupControl.setValidators(Validators.required);
    if (this.privilegeGroupSelected !== undefined && this.privilegeGroupSelected.length) {
      this.privilegeControl.clearAsyncValidators();
      this.privilegeControl.clearValidators();
    }
    if (this.privilegesSelected !== undefined && this.privilegesSelected.length) {
      this.privilegeGroupControl.clearAsyncValidators();
      this.privilegeGroupControl.clearValidators();
    }
    this.privilegeControl.updateValueAndValidity();
    this.privilegeGroupControl.updateValueAndValidity();
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}
